<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <form class="card-form" [formGroup]="dpForm" autocomplete="off" novalidate>
    <div class="blue-top">
      <img class="blue-top-logo" src="app/assets/icea-logo.png" alt="ICEA LION" />
      <span class="blue-top-title">Home Insurance Details</span>
    </div>

    <div class="card-section top-section">
      <h2>Enter IMEI details</h2>
      <p class="section-hint">Enter the IMEI number(s) of the phone(s) you would like to insure</p>

      <div formArrayName="imeiNumbers">
        <div *ngFor="let ctrl of imeiNumbers.controls; let i = index" class="imei-row">
          <mat-form-field appearance="outline" class="form-select imei-field">
            <mat-label class="form-select-placeholder-unselected">
              IMEI Number{{i > 0 ? ' ' + (i + 1) : ''}}
            </mat-label>
            <input
              matInput
              [formControlName]="i"
              maxlength="15"
              inputmode="numeric"
              spellcheck="false"
              (blur)="ctrl.markAsTouched()">
            <mat-error *ngIf="getImeiError(i)">{{getImeiError(i)}}</mat-error>
          </mat-form-field>

          <button
            mat-stroked-button
            type="button"
            class="remove-btn"
            (click)="removeImei(i)"
            *ngIf="imeiNumbers.length > 1">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>
        </div>
      </div>

      <button mat-stroked-button type="button" class="add-imei-btn" (click)="addImei()">
        <mat-icon>add</mat-icon>
        <span>Add another phone IMEI number</span>
      </button>

      <div class="row-div margin-top-50">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">Cancel</span>
        </button>
        <button mat-button type="button" [disabled]="!dpForm.valid" (click)="submitForm()">
          <span class="button-text">Save and Continue</span>
        </button>
      </div>
    </div>
  </form>
</div>
